const SHOW = 'pools/coming_soon_dialog/SHOW'
const HIDE = 'pools/coming_soon_dialog/HIDE'

export function show() {
  return { type: SHOW }
}

export function hide() {
  return { type: HIDE }
}

export default function reducer(state = { visible: false }, action) {
  if (action.type === HIDE) {
    return { visible: false }
  }
  if (action.type === SHOW) {
    return { visible: true }
  }
  return state
}
